﻿
import { Alert, Container } from '../components/ui';

export { ErrorBoundary } from 'react-error-boundary';

export const GlobalError = () => {
    return (
        <Container className="text-center my-12 py-12">
            <p className="text-xl font-light">Ooops! Something went wrong!</p>
            <p>We'll work on it and fix it as soon as we can.</p>
        </Container>
    );
}


export const Error = ({ message }) => {
    return (
        <Container className="text-center">
            <Alert variant="warning">
                {message}
            </Alert>
        </Container>
    );
}


export function logError(error, info) {
    console.error(error);
    console.error(info.componentStack);
};

